// Cột bảng "Chờ duyệt" (bài user thường gửi lên, status=0): tách riêng khỏi
// community-post-columns.js vì action khác hẳn (Duyệt/Từ chối thay vì Sửa/Xóa/Ghim).
import React from "react";
import { Button, Space, Tag, Image, Tooltip, Popconfirm } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { format } from "date-fns";
import { renderDiscountTags } from "./community-discount-tags";

const API_IMG_URL = process.env.REACT_APP_API_PUBLIC_URL || "";
const FALLBACK_IMG =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg==";

// onApprove(postId): duyệt ngay. onReject(postId): mở modal nhập lý do (xử lý ở list).
export function buildCommunityPendingColumns({ onApprove, onReject }) {
    return [
        {
            title: "Ảnh",
            dataIndex: "images",
            key: "images",
            width: 90,
            render: (images) =>
                images && images[0] ? (
                    <Image
                        src={`${API_IMG_URL}/img/post-thumbs/${images[0]}`}
                        alt="thumb"
                        width={80}
                        height={45}
                        style={{ objectFit: "cover", borderRadius: 6 }}
                        fallback={FALLBACK_IMG}
                    />
                ) : (
                    <span className="text-content-3">—</span>
                ),
        },
        {
            title: "Nội dung",
            dataIndex: "title",
            key: "title",
            render: (title, record) => (
                <div>
                    <div className="font-medium">{title}</div>
                    <div className="text-content-3 text-xs" title={record.summary}>
                        {record.summary?.length > 80 ? record.summary.slice(0, 80) + "…" : record.summary || "—"}
                    </div>
                </div>
            ),
        },
        {
            title: "Mã giảm giá",
            dataIndex: "discountCode",
            key: "discountCode",
            width: 130,
            // Nhiều mã ngăn bởi dấu phẩy -> 3 tag đầu + "+N" tooltip
            render: renderDiscountTags,
        },
        {
            title: "Danh mục",
            dataIndex: "category",
            key: "category",
            width: 130,
            render: (category) => <Tag color="blue">#{category}</Tag>,
        },
        {
            title: "Người đăng",
            dataIndex: "author",
            key: "author",
            width: 130,
            render: (author) => author?.name || "—",
        },
        {
            title: "Ngày gửi",
            dataIndex: "createTime",
            key: "createTime",
            width: 130,
            render: (ts) => (ts ? format(new Date(ts), "dd/MM/yy HH:mm") : "—"),
        },
        {
            title: "Duyệt",
            key: "action",
            width: 130,
            fixed: "right",
            render: (_, record) => (
                <Space size={4}>
                    <Tooltip title="Duyệt bài">
                        <Popconfirm
                            title="Duyệt bài đăng này?"
                            okText="Duyệt"
                            cancelText="Hủy"
                            onConfirm={() => onApprove(record.postId)}
                        >
                            <Button size="small" type="primary" icon={<FontAwesomeIcon icon={faCheck} />} />
                        </Popconfirm>
                    </Tooltip>
                    <Tooltip title="Từ chối">
                        <Button
                            size="small"
                            danger
                            icon={<FontAwesomeIcon icon={faTimes} />}
                            onClick={() => onReject(record.postId)}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];
}
